// extracted by mini-css-extract-plugin
export var blue__btn = "style-module--blue__btn--81990";
export var cost = "style-module--cost--ffd4e";
export var cost__bg = "style-module--cost__bg--51dac";
export var cost__blockBtn = "style-module--cost__block-btn--082b9";
export var cost__col = "style-module--cost__col--84fc6";
export var cost__colUnderblock = "style-module--cost__col-underblock--8425a";
export var cost__colUnderblocks = "style-module--cost__col-underblocks--40433";
export var cost__priceColor = "style-module--cost__price-color--2f9fa";
export var cost__priceOrange = "style-module--cost__price-orange--c42b3";
export var cost__priceText = "style-module--cost__price-text--9d42d";
export var cost__row = "style-module--cost__row--f8a26";
export var cost__wrapper = "style-module--cost__wrapper--36072";
export var orangeBtn = "style-module--orange-btn--c1124";
export var perMonth = "style-module--per-month--00c34";